export default __webpack_public_path__ + "static/media/star-empty-icon.58a669c0.svg";